// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AllocationItem_wrapper__1cDsx"};